import { useAuth } from '../hooks/useAuth';

export default function Profile() {
  const { user } = useAuth();

  return (
    <div className="py-12">
      <div className="section-container">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">내 정보</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Profile Card */}
          <div className="lg:col-span-1">
            <div className="card text-center">
              <div className="w-24 h-24 bg-gray-100 dark:bg-zinc-800 rounded-full mx-auto mb-4 overflow-hidden">
                {user?.avatar_url ? (
                  <img
                    src={user.avatar_url}
                    alt={user.display_name || '프로필'}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-3xl text-gray-500 dark:text-gray-400">
                    👤
                  </div>
                )}
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-1">
                {user?.display_name || '사용자'}
              </h2>
              <p className="text-gray-500 dark:text-gray-400 text-sm">{user?.email}</p>
              
              <button className="mt-4 btn-secondary w-full">
                프로필 수정
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            {/* Account Info */}
            <div className="card">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">계정 정보</h3>
              <dl className="space-y-4">
                <div className="flex justify-between py-2 border-b border-border-gray">
                  <dt className="text-gray-700 dark:text-gray-300">이메일</dt>
                  <dd className="text-gray-900 dark:text-white font-medium">{user?.email}</dd>
                </div>
                <div className="flex justify-between py-2 border-b border-border-gray">
                  <dt className="text-gray-700 dark:text-gray-300">이메일 인증</dt>
                  <dd>
                    {user?.email_verified ? (
                      <span className="text-green-600">✓ 인증됨</span>
                    ) : (
                      <span className="text-orange-500">미인증</span>
                    )}
                  </dd>
                </div>
                <div className="flex justify-between py-2">
                  <dt className="text-gray-700 dark:text-gray-300">가입일</dt>
                  <dd className="text-gray-900 dark:text-white">2026년 3월</dd>
                </div>
              </dl>
            </div>

            {/* Subscription - Placeholder */}
            <div className="card relative overflow-hidden">
              <div className="absolute inset-0 bg-pure-white/80 backdrop-blur-sm flex items-center justify-center z-10">
                <div className="text-center p-6">
                  <span className="text-4xl mb-3 block">🚀</span>
                  <p className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                    아직 구현되지 않았습니다
                  </p>
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    moldClaw를 응원해주세요!
                  </p>
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">구독 정보</h3>
              <div className="space-y-4">
                <div className="flex justify-between py-2 border-b border-border-gray">
                  <dt className="text-gray-700 dark:text-gray-300">현재 플랜</dt>
                  <dd className="text-gray-900 dark:text-white font-medium">Free</dd>
                </div>
                <div className="flex justify-between py-2">
                  <dt className="text-gray-700 dark:text-gray-300">다음 결제일</dt>
                  <dd className="text-gray-900 dark:text-white">-</dd>
                </div>
              </div>
            </div>

            {/* Usage - Placeholder */}
            <div className="card relative overflow-hidden">
              <div className="absolute inset-0 bg-pure-white/80 backdrop-blur-sm flex items-center justify-center z-10">
                <div className="text-center p-6">
                  <span className="text-4xl mb-3 block">📊</span>
                  <p className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                    아직 구현되지 않았습니다
                  </p>
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    moldClaw를 응원해주세요!
                  </p>
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">사용량</h3>
              <div className="space-y-4">
                <div>
                  <div className="flex justify-between mb-1">
                    <span className="text-gray-700 dark:text-gray-300">토큰 사용량</span>
                    <span className="text-gray-900 dark:text-white">0 / 10,000</span>
                  </div>
                  <div className="w-full bg-gray-100 dark:bg-zinc-800 rounded-full h-2">
                    <div className="bg-space-blue h-2 rounded-full" style={{ width: '0%' }}></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Danger Zone */}
            <div className="card border-red-200">
              <h3 className="text-lg font-semibold text-red-600 mb-4">계정 삭제</h3>
              <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">
                계정을 삭제하면 모든 데이터가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.
              </p>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-lg hover:bg-red-50 transition-colors">
                계정 삭제
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
